const Paths = {
  ACTIVE_SESSIONS: 'activeSessions',
  COMPLETED_SESSIONS: 'completedSessions',
  PATIENT_CLINICIANS: 'patientClinicians',
  SESSION_LEADERS: 'sessionLeaders',

  // Clinic root path
  clinicRoot(clinicId: string) {
    return `clinics/${clinicId}`;
  },

  // Full paths (from database root)
  activeSession(clinicId: string, sessionKey: string) {
    return `${this.clinicRoot(clinicId)}/${this.ACTIVE_SESSIONS}/${sessionKey}`;
  },

  patientClinicians(clinicId: string, patientId: string, clinicianId: string) {
    return `${this.clinicRoot(clinicId)}/${
      this.PATIENT_CLINICIANS
    }/${patientId}/activeClinicianIds/${clinicianId}`;
  },

  // Relative paths (from clinic root)
  relativeActiveSession(sessionKey: string) {
    return `${this.ACTIVE_SESSIONS}/${sessionKey}`;
  },

  relativeCompletedSession(sessionKey: string, timestamp: string) {
    return `${this.COMPLETED_SESSIONS}/${sessionKey}/${timestamp}`;
  },

  relativePatientClinicians(patientId: string, clinicianId: string) {
    return `${this.PATIENT_CLINICIANS}/${patientId}/activeClinicianIds/${clinicianId}`;
  },

  // Session leaders paths
  sessionLeaders(clinicId: string) {
    return `${this.clinicRoot(clinicId)}/${this.SESSION_LEADERS}`;
  },

  sessionLeader(clinicId: string, index: number) {
    return `${this.sessionLeaders(clinicId)}/${index}`;
  },
};

export default Paths;
